var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"walk-marquee bg-black text-white d-flex "},[_c('span',[_vm._v(_vm._s(_vm.marqueeText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }